import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { BackToSearch } from './tracking-page.actions';
import { selectReviewsEnabled } from './tracking-page.selectors';
import {
  BootstrapTrackingPage,
  FetchTrackingPageBySubdomain,
  FindTrackingPageNumber,
  FindTrackingPageNumberPayload
} from './tracking-page.actions';
import {
  selectTrackingPageHash,
  selectTrackingPage,
  selectTrackingPageLoaded,
  selectNoTrackingNumberFound
} from './tracking-page.selectors';

@Injectable()
export class TrackingPageFacade {
  constructor(private store: Store<any>) {}

  public readonly hash$ = this.store.pipe(select(selectTrackingPageHash));

  public readonly trackingPage$ = this.store.pipe(select(selectTrackingPage));

  public readonly reviewsEnabled$ = this.store.pipe(
    select(selectReviewsEnabled)
  );

  public readonly trackingPageLoaded$ = this.store.pipe(
    select(selectTrackingPageLoaded)
  );

  public readonly noTrackingNumberFound$ = this.store.pipe(
    select(selectNoTrackingNumberFound)
  );

  bootstrapTrackingPage(
    hash: string,
    locale: string = 'en',
    redirectOnError: boolean = true,
    domain?: string
  ) {
    this.store.dispatch(
      new BootstrapTrackingPage({ hash, locale, redirectOnError, domain })
    );
  }

  fetchTrackingPageBySubdomain(
    subdomain: string,
    locale,
    redirectOnError: boolean = true
  ) {
    this.store.dispatch(
      new FetchTrackingPageBySubdomain({ subdomain, locale, redirectOnError })
    );
  }

  findTrackingPageNumber(params: FindTrackingPageNumberPayload) {
    this.store.dispatch(new FindTrackingPageNumber(params));
  }

  backToSearch() {
    this.store.dispatch(new BackToSearch());
  }
}
